import { DialogTitle, FormControl, FormLabel, Input, Modal, ModalDialog, Stack, Typography, Checkbox, Button } from '@mui/joy';
import React, { useEffect } from 'react';
import { IMappedLogInvoice } from '../interface/IWorklog';

type Props = {
  open: boolean;
  submitting: boolean;
  onClose: () => void;
  onSubmit: () => void;
  invoices: IMappedLogInvoice[];
  onChangeInvoice: <T extends keyof IMappedLogInvoice>(offerId: string, key: T, value: IMappedLogInvoice[T]) => void;
};

const InvoiceSubmitModal = ({ open, onClose, onSubmit, invoices, onChangeInvoice, submitting }: Props) => {
  useEffect(() => {
    if (open) {
    } else {
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby='modal-title'
      aria-describedby='modal-desc'
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <ModalDialog>
        <DialogTitle>Submit Invoices</DialogTitle>
        <form
          onSubmit={async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            try {
              onSubmit();
            } catch (e) {
              console.error(e);
            }
          }}
        >
          {invoices.map((inv) => (
            <Stack key={inv.offerId} spacing={2} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
              <FormControl required>
                <FormLabel>Offer</FormLabel>
                <Input type='text' name='offerId' value={inv.offerId} readOnly />
              </FormControl>
              {inv.checked && (
                <>
                  <FormControl required>
                    <FormLabel>Invoice Date</FormLabel>
                    <Input
                      name='invoiceDate'
                      type='date'
                      value={inv.invoiceDate}
                      onChange={(e) => {
                        onChangeInvoice(inv.offerId, 'invoiceDate', e.target.value);
                      }}
                    />
                  </FormControl>
                  <FormControl required>
                    <FormLabel>Due Date</FormLabel>
                    <Input type='date' name='dueDate' value={inv.dueDate} onChange={(e) => onChangeInvoice(inv.offerId, 'dueDate', e.target.value)} />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Send Mail</FormLabel>
                    <Checkbox
                      disabled={!inv.offer}
                      name='sendEmail'
                      checked={inv.sendEmail || false}
                      onChange={(e) => onChangeInvoice(inv.offerId, 'sendEmail', e.target.checked)}
                    />
                  </FormControl>
                </>
              )}
            </Stack>
          ))}

          <Button type='submit' style={{ marginTop: 15 }} loading={submitting}>
            Submit
          </Button>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default InvoiceSubmitModal;
